import React,{ FC, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { getInvoiceOrder } from "~src/service/bill";
import { InvoiceOrderType } from "~src/service/bill/bill";
import useQuery from "~src/hooks/useQuery";
import { Empty, InfiniteScroll } from "antd-mobile";
import Copy from "~src/components/Copy";


interface  RelatedCardProps {
  item: InvoiceOrderType
}

const RelatedCard:FC<RelatedCardProps> = ({item}) => {
  return <div className={styles.card}>
    <div className={styles["card-header"]}>
      <span>订单编号：  </span>
      <Copy text={item.orderNo} />
    </div>
    <div className={styles["card-content"]}>{item.title}</div>
    <div className={styles["card-footer"]}>
      <div>订单时间：{item.orderTime}</div>
      <div>
        <span>¥</span>
        <span className={styles["card-footer-unit"]}>{item.totalAmount}</span>
      </div>
    </div>
  </div>
}

const BillRelated: FC = () => {
  useDocumentTitle(`关联记录`)
  const searchQuery = useQuery()
  const id = searchQuery("id")
  const biz = searchQuery("biz")
  const [list, setList] = useState<InvoiceOrderType[]>([])
  const [hasMore, setHasMore] = useState<boolean>(false)
  const conf = useRef({
    page: 0,
    pageSize: 10,
    outInvoiceId: id,
    bizName: biz || "charge"
  })
  const loadMore = async() =>{
    conf.current.page += 1
    const {list, hasNext} = await getInvoiceOrder(conf.current)
    setList(val => [...val, ...list])
    setHasMore(hasNext)
  }
  const doSearch = () => {
    setList([])
    setHasMore(true)
    loadMore()
  }
  useEffect(() => {
    doSearch()
  }, [])

  return <div className={styles.related}>
   {list.length > 0 ? (
        <>
            {list.map((item, index) => (
                  <div key={item.orderNo} className={styles["related-item"]}><RelatedCard item={item}/></div>
            ))}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </>
      ) : <Empty description='暂无数据' />
    }
  </div>
}
export default BillRelated